export const formFields = {
    email: {
        key: 'email',
        type: 'text',
        label: 'Email',
        required: true,
        placeholder: 'Email',
        requiredMessage: 'Email is required',
        displayLayout: 'col-sm-12',
        pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        maxLength: 80,
        maxLengthMessage: 'maximum 80 characters allowed.',
        spaceNotAllowed: true,
        labelLayout: 'col-sm-12'
    }
};